import Promise from 'bluebird'
import fetchClient from 'lib/fetch_client'
import routes from 'server_routes'
import { INFLATE as INFLATE_USER_TXNS } from './user_txns'
import { getI18n } from 'client/i18n'
import { NEW_CAMPAIGN_ID } from 'redux/modules/campaign'
import { getTxnsSelector } from 'redux/selectors/contributions'
import { CREATE_DNW_TRANSACTION_SUCCESS } from './dnw_transaction'

const MOCK_TXN_COUNT = 3
const i18n = getI18n('components/txns_list')

export const SET_TXN_LIST = 'pools/txns/SET_TXN_LIST'
export const FINISH_TXNS_SHOW_MORE = 'pools/txns/FINISH_UPLOAD'

export default function reducer(
  state = { list: [], txns_per_page: 10 },
  action
) {
  switch (action.type) {
    case SET_TXN_LIST:
      return { ...state, list: action.list, total: action.total }
    case INFLATE_USER_TXNS:
      return { ...state, list: [...action.payload.list, ...state.list] }
    case CREATE_DNW_TRANSACTION_SUCCESS: {
      return {
        ...state,
        list: [action.payload.txn, ...state.list],
      }
    }
    default:
      return state
  }
}

export function mockForPreview(
  shareProgress,
  shareContributorsDetails,
  shareContributionsAmount
) {
  if (shareContributorsDetails || (shareContributionsAmount && shareProgress)) {
    return {
      type: SET_TXN_LIST,
      list: Array.from({ length: MOCK_TXN_COUNT }, (_, id) => ({
        id: id.toString(),
        campaign_id: NEW_CAMPAIGN_ID,
        sender_name: i18n(
          shareContributorsDetails ? 'participant_name' : 'anonymous'
        ),
        date: i18n('date'),
        amount: shareContributionsAmount ? 0 : undefined,
      })),
    }
  }
  return { type: SET_TXN_LIST, list: null }
}

export function showMoreTxns(campaignId, fromIndex, howMany) {
  // show more actually fetches just the photos of the additional txns, since the txns are already in the client.
  return (dispatch, getState) => {
    const state = getState()
    const txnsToQuery = getTxnsSelector(state, { campaignId }).slice(
      fromIndex,
      fromIndex + howMany
    )
    let idsToQuery = txnsToQuery
      .map(txn => txn.contributor_id)
      .filter(id => !!id)
    const idsToQueryPhoto = idsToQuery.filter(
      id => state.contributors.map[id] && !state.contributors.map[id].photo
    ) // filter ids with an image
    const fetchPhotos = fetchClient().request(
      routes.contributors.api.photos(),
      {
        query: {
          ids: encodeURIComponent(JSON.stringify(idsToQueryPhoto)),
        },
        method: 'GET',
      }
    )

    const idsToQueryBusinessName = idsToQuery.filter(
      id =>
        state.contributors.map[id] &&
        !state.contributors.map[id].has_business_name
    )
    const fetchBusinessNames = fetchClient().request(
      routes.contributors.api.businessnames(),
      {
        query: {
          ids: encodeURIComponent(JSON.stringify(idsToQueryBusinessName)),
        },
        method: 'GET',
      }
    )
    return Promise.all([fetchPhotos, fetchBusinessNames])
      .then(responses => {
        dispatch(
          finishShowMoreTxns({
            ...responses[0],
            ...responses[1],
          })
        )
      })
      .catch(() => {
        dispatch(finishShowMoreTxns({}))
      })
  }
}

export function finishShowMoreTxns(response) {
  return { type: FINISH_TXNS_SHOW_MORE, payload: { response } }
}
